import { render, staticRenderFns } from "./EllipsisText.vue?vue&type=template&id=00f281aa&"
import script from "./EllipsisText.vue?vue&type=script&lang=js&"
export * from "./EllipsisText.vue?vue&type=script&lang=js&"
import style0 from "./EllipsisText.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports